import { ReactNode } from 'react';

import { useAbove } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../styles/media';
import { aboveStyles } from '../../styles/responsive.css';

interface AboveProps {
    bp: Breakpoint;
    children: ReactNode;
    avoidRendering?: boolean;
}

function AboveWithMatchMedia({ bp, children }: { bp: Breakpoint; children: ReactNode }) {
    const matches = useAbove(bp);
    return matches ? children : null;
}

export function Above({ bp, children, avoidRendering = false }: AboveProps) {
    // Use matchMedia to avoid rendering if avoidRendering is true
    if (avoidRendering) {
        return <AboveWithMatchMedia bp={bp}>{children}</AboveWithMatchMedia>;
    }

    // Use CSS to hide/show (always renders)
    return <div className={aboveStyles[bp]}>{children}</div>;
}
